<template>
	<div>
		


		<panel class="border border-secondary rounded mb-4" :noButton="true">
			<template slot="header">
				<h5>Pengecekan Kondisi Mobil - Depan</h5>
			</template>
			<!-- <div class="p-10 w-100">
				<h5>Tipe Mobil</h5>
				<div class="row">
					
					<div class="col-6 col-md-3" style="padding-right:0;">
						<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'sedan', 'btn-outline-info' : carTypes != 'sedan'}" 
							style="border-radius:5px 0px 0px 5px;border-right: none" type="button"
							@click="carTypes = 'sedan'"
						>
							Sedan
						</button>
					</div>
					<div class="col-6 col-md-3" style="padding-left:0">
						<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'minibus', 'btn-outline-info' : carTypes != 'minibus'}" 
							style="border-radius:0px 5px 5px 0px;" type="button"
							@click="carTypes = 'minibus'"
						>
							Minibus
						</button>
					</div>
				</div>
			</div> -->
			<div class="row mt-3">
				<div class="col-sm-4 col-lg-2 col-12 label-car-type">
					<label>Pilih Jenis Kendaraan :</label>
				</div>
				<div class="col-sm-3 col-lg-2 col-6">
					<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'sedan', 'btn-outline-info' : carTypes != 'sedan'}" 
							style="border-radius:50px" type="button"
							@click="carTypes = 'sedan'"
						>
							Sedan
						</button>
				</div>
				<div class="col-sm-3 col-lg-2 col-6">
					<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'minibus', 'btn-outline-info' : carTypes != 'minibus'}" 
							style="border-radius:50px" type="button"
							@click="carTypes = 'minibus'"
						>
							Minibus
						</button>
				</div>
			</div>
			

			<div class="row mt-4" >
				<!-- <div class="col-md-9 col-sm-12 col-12 " style="overflow-x:scroll">
					<div class="workOrderParent" :class="{'workOrderOuterFrontSedan' : carTypes == 'sedan', 'workOrderOuterFrontMinibus' : carTypes == 'minibus'}">
						<div v-else class="workOrderInnerFrontMinibus">
							<div class="carWindowFrontMinibus" v-on:click="selectPart('front.carWindowDepan' , carTypes)" :class="{'carWindowFrontMinibusActive' : data.condition.figure.minibus.front.carWindowDepan.desc != ''}">
							</div>
							<div class="spionDepanKiriMinibus" v-on:click="selectPart('front.spionDepanKiri' , carTypes)" :class="{'spionDepanKiriMinibusActive' : data.condition.figure.minibus.front.spionDepanKiri.desc != ''}">
							</div>
							<div class="spionDepanKananMinibus" v-on:click="selectPart('front.spionDepanKanan' , carTypes)" :class="{'spionDepanKananMinibusActive' : data.condition.figure.minibus.front.spionDepanKanan.desc != ''}">
							</div>
							<div class="kapMesinMinibus" v-on:click="selectPart('front.kapMesin' , carTypes)" :class="{'kapMesinMinibusActive' : data.condition.figure.minibus.front.kapMesin.desc != ''}">
							</div>
							<div class="headLightKiriMinibus" v-on:click="selectPart('front.headLightKanan' , carTypes)" :class="{'headLightKiriMinibusActive' : data.condition.figure.minibus.front.headLightKanan.desc != ''}">
							</div>
							<div class="headLightKananMinibus" v-on:click="selectPart('front.headLightKiri' , carTypes)" :class="{'headLightKananMinibusActive' : data.condition.figure.minibus.front.headLightKiri.desc != ''}">
							</div>
							<div class="fogLightKiriMinibus" v-on:click="selectPart('front.fogLightKanan' , carTypes)" :class="{'fogLightKiriMinibusActive' : data.condition.figure.minibus.front.fogLightKanan.desc != ''}">
							</div>
							<div class="fogLightKananMinibus" v-on:click="selectPart('front.fogLightKiri' , carTypes)" :class="{'fogLightKananMinibusActive' : data.condition.figure.minibus.front.fogLightKiri.desc != ''}">
							</div>
							<div class="grillMinibus" v-on:click="selectPart('front.grill' , carTypes)" :class="{'grillMinibusActive' : data.condition.figure.minibus.front.grill.desc != ''}">
							</div>
							<div class="emblemMinibus" v-on:click="selectPart('front.emblem' , carTypes)" :class="{'emblemMinibusActive' : data.condition.figure.minibus.front.emblem.desc != ''}">
							</div>
							<div class="bemperDepanMinibus" v-on:click="selectPart('front.bumperDepan' , carTypes)" :class="{'bemperDepanMinibusActive' : data.condition.figure.minibus.front.bumperDepan.desc != ''}" />


						</div>						
					</div>
				</div> -->
				
				<div class="col-12 p-10" style="overflow-x:scroll">

					

					
					<div class="workOrderParent" :class="{'workOrderOuterFrontSedan' : carTypes == 'sedan', 'workOrderOuterFrontMinibus' : carTypes == 'minibus'}" style="overflow-x:scroll" v-if="!exit">
							
						<template v-if="carType == 'sedan'">
							<div class="workOrderInnerFrontSedan h-100 w-100" style="z-index:100"  @mousedown="(e) => {this.addShape(e , null)}">
							</div>
							<canvas class="workOrderInnerFrontSedan h-100 w-100"  id="canvasSedan" style="z-index:50;" >
								
							</canvas>
						</template>
						<template v-else>
							<div class="workOrderInnerFrontMinibus h-100 w-100" style="z-index:100"  @mousedown="(e) => {this.addShape(e , null)}">
							</div>
							<canvas class="workOrderInnerFrontMinibus h-100 w-100"  id="canvasMinibus" style="z-index:50;" >
								
							</canvas>
						</template>
							
						
					</div>

					<div v-else>
							<img v-if="imageSrc" :src="env.baseImage + '/' + imageSrc"  class="workOrderParent"/>

							<div v-else class="mt-5 mb-5 text-center">
								<h2>Tidak Melakukan Tanda Terima</h2>
							</div>

					</div>
					
					
				</div>

				<div class="col-12 row mt-1 mb-5" v-if="!exit">
					<div class="col-12 mb-2 pl-4 mt-2">
						<label>Pilih Kondisi Berikut untuk Menandai Mobil</label>
					</div>
					<!-- <div class="col-md-2 col pl-4">
						<button :class="{'btn-secondary' : curShape == 'Boncel' , 'btn-outline-secondary' : curShape != 'Boncel'}" class="btn w-100" @click="curShape = 'Boncel'"><i class="fa fa-circle fa-lg mr-2"></i> Boncel</button>
					</div>
					<div class="col-md-2 col pl-4">
						<button :class="{'btn-secondary' : curShape == 'Baret' , 'btn-outline-secondary' : curShape != 'Baret'}" class="btn w-100" @click="curShape = 'Baret'"><i class="fa fa-grip-lines fa-lg mr-2"></i> Baret</button>
					</div>
					<div class="col-md-2 col pl-4">
						<button :class="{'btn-secondary' : curShape == 'Penyok' , 'btn-outline-secondary' : curShape != 'Penyok'}" class="btn w-100" @click="curShape = 'Penyok'"><i class="fa fa-times fa-lg mr-2"></i> Penyok</button>
					</div>
					<div class="col-md-2 col pl-4">
						<button :class="{'btn-secondary' : curShape == 'Pecah' , 'btn-outline-secondary' : curShape != 'Pecah'}" class="btn w-100" @click="curShape = 'Pecah'"><i class="fa fa-exclamation-triangle fa-lg mr-2"></i> Pecah</button>
					</div> -->
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-green' : curShape == 'Boncel' , 'btn-outline-secondary' : curShape != 'Boncel'}" class="btn w-100" @click="curShape = 'Boncel'"><i class="fa fa-circle fa-lg mr-2 color-green"></i> Boncel</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-blue' : curShape == 'Baret' , 'btn-outline-secondary' : curShape != 'Baret'}" class="btn w-100" @click="curShape = 'Baret'"><i class="fa fa-circle fa-lg mr-2 color-blue"></i> Baret</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-yellow' : curShape == 'Penyok' , 'btn-outline-secondary' : curShape != 'Penyok'}" class="btn w-100" @click="curShape = 'Penyok'"><i class="fa fa-circle fa-lg mr-2 color-yellow"></i> Penyok</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-red' : curShape == 'Pecah' , 'btn-outline-secondary' : curShape != 'Pecah'}" class="btn w-100" @click="curShape = 'Pecah'"><i class="fa fa-circle fa-lg mr-2 color-red"></i> Pecah</button>
					</div>
					<div class="col-sm-4 col-12 offset-lg-2 col-lg-2 pl-4 text-right mt-2">
						<button class="btn btn-danger w-100" @click="reset">Reset</button>
					</div>
						
				</div>
				<div class="col-12" style="">
					<h4 class="text-center">Kondisi {{carTypes.charAt(0).toUpperCase() + carTypes.slice(1)}}</h4>
					<hr>
					<div class="row">
						<div class="col-4 h-100" v-for="checklistCar in Object.keys(data.condition.figure[carTypes].front)" :key="checklistCar">
							<div class="row mt-2">
								<div class="col-6">
									<p>{{translatePart(checklistCar).split(/(?=[A-Z])/).join(' ')}}</p>
									
								</div>
								<div class="col-6 text-center">
									<input type="checkbox" disabled  v-model="data.condition.figure[carTypes].front[checklistCar].desc" >
								</div>
							</div>
							<p v-if="exit && data.condition.figure[carTypes].front[checklistCar].desc != ''" style="font-weight:bold">Deskripsi Rusak : <br>{{data.condition.figure[carTypes].front[checklistCar].desc}}</p>
							<template v-else-if="exit">
								<div class="mt-5"></div>
							</template>
							<hr style="margin-top:5px;margin-bottom:5px;">
						</div>
					</div>
					
				</div>
			</div>

			
			
		</panel>

		<div class="row">
			<div class="col-md-6 col-0">
			</div>
			<div class="col-md-3 col-6">
				<button type="button" class="btn btn-danger w-100 rounded" @click="$emit('backPage');">Sebelumnya</button>
			</div>
			<div class="col-md-3 col-6">
				<button type="button" class="btn btn-primary w-100 rounded" @click="nextPage" :disabled="apiLoading">Berikutnya</button>
			</div>
		</div>

		<modalUploadImage :varHeader="partHeader" :var="part" :part="translatePart(part)" @showModalFalse="showModal = false" v-if="showModal" @uploadImage="uploadImage"/>

	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import modalUploadImage from './modalUploadImage'
	import env from '@/env'

	export default {
		components: {
			Multiselect,
			modalUploadImage

		},
		data () {
			return {
				env,
				showModal: false,
				hover : false,
				part: '',
				partHeader : '',
				showFrontModal: false,
				checkSettings : this.data.condition.checklist,
				carTypes : this.carType,
				listCarTypes : null,
				listOfPoints : [],
				click : null, 
				preventRepeat : {},
				gridMap : null,
				gripMapMinibus : null,
				selected : [],
				curShape : 'Boncel',
				imageSrc : ''
				
			}
		},
		props: ['page', 'data', 'checklistSettings' , 'carType' , 'title' , 'previousCheckingCondition' , 'exit' , 'apiLoading'],
		mounted () {

			this.loadGridCanvas()

			if(this.exit)
				this.imageSrc = this.previousCheckingCondition.condition.figureOverall.front.image.length > 0 
				&& this.previousCheckingCondition.condition.figureOverall.front.image[0] != 'test image'? 
					this.previousCheckingCondition.condition.figureOverall.front.image[0]
					: null
			
			this.$http.get('/api/v1/masterData/car/type')
			.then((resp) => {
				this.listCarTypes = resp.data.data
				if(this.exit) {
					// console.log(this.previousCheckingCondition.customer_car)
					this.carType = this.previousCheckingCondition.customer_car.car_type_id == 2 ? 'sedan' : 'minibus'
					this.carTypes = this.carType

					let keys = Object.keys(this.data.condition.figure[this.carType].front)
					// console.log(this.previousCheckingCondition.condition.figure.front);

					for(var i = 0 ; i < keys.length ; i++) {
						let nowCondition = this.data.condition.figure[this.carType].front[keys[i]]
						let prevCondition = this.previousCheckingCondition.condition.figure.front[keys[i]]
						if(prevCondition.desc != '') {
							nowCondition.desc = prevCondition.desc
							console.log(nowCondition)
						}
					}

				}
				else 

					this.data.customer_car.car_type_id = this.listCarTypes.find(x => x.name.toLowerCase() == this.carTypes).id
			})
			.catch((err) => {
				console.log(err)
			})
		},
		watch : {
			carTypes : function () {
				this.$emit('changeCarType' , this.carTypes)
				this.data.customer_car.car_type_id = this.listCarTypes.find(x => x.name.toLowerCase() == this.carTypes).id
			}
		},
		methods: {
			async loadGridCanvas () {
				let col = [6 , 26 ,  15,  10, 5, 9, 70, 7, 43, 28, 37, 28, 42, 7, 71, 10, 3, 12, 15, 27];
				let row = [25, 60, 21, 15, 28, 10, 10, 6, 16, 14 ,21, 51, 10];
				let  obj = [{
					name : 'front.carWindowDepan',
					startCol : 7,
					endCol  : 16,
					startRow : 2 , 
					endRow : 4
				}, {
					name : 'front.spionDepanKiri',
					startCol : 17,
					endCol  : 21,
					startRow : 3 , 
					endRow : 5
				},{
					name : 'front.spionDepanKanan',
					
					startCol : 2,
					endCol  : 5,
					startRow : 3 , 
					endRow : 5
				}, {
					name : 'front.kapMesin',
					startCol : 6,
					endCol  : 17,
					startRow : 4 , 
					endRow : 7
				}, {
					name : 'front.headLightKanan',
					
					startCol : 4,
					endCol  : 9,
					startRow : 6 , 
					endRow : 10
					
				}, {
					name : 'front.headLightKiri',
					startCol : 14,
					endCol  : 19,
					startRow : 7 , 
					endRow : 10
				}, {
					name : 'front.grill',
					startCol : 8,
					endCol  : 15,
					startRow : 9 , 
					endRow : 11
				}, {
					name : 'front.emblem',
					startCol : 11,
					endCol  : 12,
					startRow : 8 , 
					endRow : 10
				}, {
					name : 'front.bumperDepan',
					startCol : 3,
					endCol  : 20,
					startRow : 8 , 
					endRow : 14
				}, {
					name : 'front.fogLightKiri',
					startCol : 13,
					endCol  : 19,
					startRow : 12 , 
					endRow : 13
				}, {
					name : 'front.fogLightKanan',
					
					startCol : 4,
					endCol  : 10,
					startRow : 12 , 
					endRow : 13
				}]

				let colMinibus = [13, 39.5, 9, 7, 3.5, 12, 3, 33, 18, 25, 81, 50, 81, 25, 18, 33, 7, 8, 4, 7, 10, 47]
				let rowMinibus = [40, 77, 47, 5, 22, 10, 16, 6, 22, 8, 19, 6, 54, 37, 25]
				let objMinibus = [{
					name : 'front.carWindowDepan',
					startCol : 8,
					endCol  : 18,
					startRow : 2 , 
					endRow : 5
				},{
					name : 'front.spionDepanKiri',
					startCol : 19,
					endCol  : 23,
					startRow : 3 , 
					endRow : 5
				},{
					name : 'front.spionDepanKanan',
					
					startCol : 2,
					endCol  : 6,
					startRow : 3 , 
					endRow : 5
				},{
					name : 'front.kapMesin',
					startCol : 7,
					endCol  : 18,
					startRow : 4 , 
					endRow : 8
				},{
					name : 'front.headLightKanan',
					startCol : 14,
					endCol  : 21,
					startRow : 6 , 
					endRow : 12
				},{
					name : 'front.headLightKiri',
					startCol : 4,
					endCol  : 11,
					startRow : 6 , 
					endRow : 12
				},{
					name : 'front.fogLightKanan',
					startCol : 5,
					endCol  : 9,
					startRow : 14 , 
					endRow : 15
				},{
					name : 'front.fogLightKiri',
					startCol : 16,
					endCol  : 20,
					startRow : 14 , 
					endRow : 15
				},{
					name : 'front.grill',
					startCol : 10,
					endCol  : 15,
					startRow : 7 , 
					endRow : 13
				},{
					name : 'front.emblem',
					startCol : 12,
					endCol  : 13,
					startRow : 9 , 
					endRow : 11
				},{
					name : 'front.bumperDepan',
					startCol : 3,
					endCol  : 22,
					startRow : 10 , 
					endRow : 16
				}]

				this.gridMap = await this.mapGridCanvas(col , row , obj)
				this.gripMapMinibus = await this.mapGridCanvas(colMinibus , rowMinibus , objMinibus)
			},
			async mapGridCanvas(col , row , obj) {
			
				for(var i = 0 ; i < obj.length ; i++) {
					let curObj = obj[i]
					curObj.startColLength= col.slice(0 , curObj.startCol - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.endColLength = col.slice(0, curObj.endCol - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.startRowLength= row.slice(0 , curObj.startRow - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.endRowLength = row.slice(0, curObj.endRow - 1).reduce((partial_sum, a) => partial_sum + a, 0)
				}

				

				return obj
			},
			addShape(e = null ,click) {
				if(!e) {
					this.listOfPoints.length = 0
					this.selected.length = 0
				}
				else {
					let x = 0
					let y = 0

					x = e.offsetX
					y = e.offsetY
					// console.log(x, y)
					let selectedGrid = this.carTypes == 'sedan' ? this.gridMap : this.gripMapMinibus

					let area = selectedGrid.filter(z => 
						z.startColLength <=  x &&
						z.endColLength >= x &&
						z.startRowLength <= y &&
						z.endRowLength >= y
					)

					if(area.length > 0) {
						// this.selected.push(area.name)
						if(area.length == 1)
							this.data.condition.figure[this.carTypes].front[area[0].name.split('.')[1]] = {
								desc : this.curShape
							}
						else {
							let res = []

							for(var i = 0 ; i < area.length ; i++) {
								let z = area[i]
								res[i] = (z.endColLength - x) + (z.endRowLength - y)
								// console.log(z.name , res[i])
							}

							var max = Math.min(...res)
							let index = res.indexOf(max)
							// console.log(index , max)

							

							// this.selectPart(area[index].name , this.carTypes)
							this.data.condition.figure[this.carTypes].front[area[index].name.split('.')[1]] = {
								desc : this.curShape
							}
						}
					}
					this.listOfPoints.push({x , y , shape : this.curShape})
				}
				// console.log(click)
				
				let canvas = null
				let context = null

				if(this.carTypes == 'sedan') {
					canvas = document.getElementById('canvasSedan');
					context = canvas.getContext('2d');
					canvas.width = 476.7
					canvas.height = 342.03
				}
				else {
					canvas = document.getElementById('canvasMinibus');
					context = canvas.getContext('2d');
					canvas.width = 544.83
					canvas.height = 450	
				}
				

				
			
				
				for(var i = 0 ; i < this.listOfPoints.length ; i++) {
					context.beginPath();

					let x = this.listOfPoints[i].x
					let y = this.listOfPoints[i].y

					let fillStyle = '';

					if(this.listOfPoints[i].shape == 'Boncel')
						fillStyle = '#29BC53'
					else if(this.listOfPoints[i].shape == 'Penyok')
						fillStyle = '#FFDD05'
					else if(this.listOfPoints[i].shape == 'Baret')
						fillStyle = '#007ED9'
					else if(this.listOfPoints[i].shape == 'Pecah')
						fillStyle = '#FF0000'

					// console

					context.moveTo( this.listOfPoints[i].x + 7.5, this.listOfPoints[i].y );
					context.arc(this.listOfPoints[i].x, this.listOfPoints[i].y, 7.5 ,2*Math.PI,0 *Math.PI);
					context.fillStyle = fillStyle;
					context.fill();
					context.stroke();

					// if(this.listOfPoints[i].shape == 'Boncel') {
					// 	context.moveTo( this.listOfPoints[i].x + 7.5, this.listOfPoints[i].y );


					// 	context.arc(this.listOfPoints[i].x, this.listOfPoints[i].y, 7.5 ,2*Math.PI,0 *Math.PI);
					// 	context.fillStyle = 'black';
					// 	context.fill();
					// 	context.stroke();
					// 	// console.log(String.fromCharCode(this.listOfPoints[i].shape))
					// }
					// else if (this.listOfPoints[i].shape == 'Penyok') {
					// 	context.beginPath();

					// 	context.moveTo(x - 7.5, y - 7.5);
					// 	context.lineTo(x + 7.5, y + 7.5);

					// 	context.moveTo(x + 7.5, y - 7.5);
					// 	context.lineTo(x - 7.5, y + 7.5);
					// 	context.stroke();
					// }
					// else if (this.listOfPoints[i].shape == 'Baret') {
					// 	context.beginPath();

					// 	context.moveTo(x - 7.5, y);
					// 	context.lineTo(x + 7.5 , y);

					// 	context.moveTo(x - 7.5, y + 7.5);
					// 	context.lineTo(x + 7.5, y + 7.5);
					// 	context.stroke();
					// }
					// else {
					// 	context.beginPath();

					// 	context.moveTo(x, y - 15);
					// 	context.lineTo(x - 7.5, y );
					// 	context.lineTo(x + 7.5, y );
					// 	context.fill();
					// }

					
					
					
					// context.fillText(this.listOfPoints[i].shape, this.listOfPoints[i].x, this.listOfPoints[i].y);
					// context.fill();
					// context.stroke();
				}
				// var dataURL = canvas.toDataURL();
				// console.log(dataURL)
				
				
			},
			reset() {
				this.addShape(null)

				this.data.condition.figureOverall[this.carTypes].front = { image : [] }

				let keys = Object.keys(this.data.condition.figure[this.carTypes].front)
				// console.log(keys)

				for(var i = 0 ; i < keys.length ; i++) {
					this.data.condition.figure[this.carTypes].front[keys[i]] = { desc : '' }
				}
			},
			// checked(part) {
			// 	this.checkSettings[part] = !this.checkSettings[part]
			// },
			// selectPart (part , carTypes) {
			// 	if(this.exit) {
			// 		this.$store.dispatch('triggerAlert' , [false , 'Fitur Dinonaktifkan untuk Tutup Work Order'])
			// 		return
			// 	}

			// 	let partString = part.split('.')
			// 	if(this.data.condition.figure[carTypes][partString[0]][partString[1]] && this.data.condition.figure[carTypes][partString[0]][partString[1]].desc != '') {
					
			// 		this.$swal.fire({
			// 			title: 'Apakah anda yakin?',
			// 			icon: 'warning',
			// 			showCancelButton: true,
			// 			confirmButtonColor: '#3085d6',
			// 			cancelButtonColor: '#d33',
			// 			confirmButtonText: 'Saya Yakin',
			// 			cancelButtonText: 'Kembali'
			// 		}).then((result)=>{
			// 			if(result.value){
			// 				this.data.condition.figure[carTypes][partString[0]][partString[1]].desc = ''
			// 				this.data.condition.figure[carTypes][partString[0]][partString[1]].image = [false]
			// 			}
			// 		})
			// 	}
			// 	else {
			// 		this.showModal = true
			// 		this.part = partString[1]
			// 		this.partHeader = 'figure'
			// 	}
			// },
			uploadImage (partHeader , part, url) {
				if(partHeader != 'figureOverall')
					this.data.condition[partHeader][this.carTypes].front[part] = url
				else 
					this.data.condition[partHeader][this.carTypes][part] = url
				// alert("Unggah Gambar Berhasil!")

				this.$store.dispatch('triggerAlert', [true, ['Unggah Gambar Berhasil']])
				this.showModal = false

				if(partHeader == 'figureOverall')
					this.$emit('nextPage')
			},
			translatePart (str) {
				let strSplit = str.split("_").reverse()

				for (var i = 0 ; i < strSplit.length ; i ++) {
					
					if(strSplit[i] == 'front')
						strSplit[i] = 'depan'
					else if (strSplit[i] == 'rear')
						strSplit[i] = 'belakang'
					else if (strSplit[i] == 'left')
						strSplit[i] = 'kiri'
					else if (strSplit[i] == 'right')
						strSplit[i] = 'kanan'
					else if (strSplit[i] == 'wheel')
						strSplit[i] = 'roda'
					else if (strSplit[i] == 'door')
						strSplit[i] = 'pintu'
					else if (strSplit[i] == 'light')
						strSplit[i] = 'lampu'
					else if (strSplit[i] == 'car')
						strSplit[i] = 'mobil'
					else if (strSplit[i] == 'window')
						strSplit[i] = 'kaca'

					strSplit[i] = strSplit[i].charAt(0).toUpperCase() + strSplit[i].slice(1)
				}

				return strSplit.join(" ")
			},
			nextPage () {
				
				if(this.data.condition.figureOverall[this.carTypes].front.image.length > 1) {
					this.$emit('nextPage')
				}
				if(this.exit) {
					this.showModal = true;
					this.part = 'front'
					this.partHeader = 'figureOverall'
					return
				}
				var destinationCanvas = document.createElement("CANVAS");
				var destCtx = destinationCanvas.getContext('2d');

				var background = new Image();
				let canvasId = this.carTypes == 'sedan' ? 'canvasSedan' : 'canvasMinibus'
				let param = {}

				if(this.carTypes == 'sedan') {
					destinationCanvas.width = 476.7
					destinationCanvas.height = 342.03
					
					background.src = "/img/WorkOrder/Sedan/CAMRY FRONT.svg";
					param.width = 650
					param.height = 342.03
					param.offsetX = -87.5
					param.offsetY = 0
				}
				else {
					destinationCanvas.width = 544.83
					destinationCanvas.height = 450
					
					background.src = "/img/WorkOrder/Minibus/ALPHARD FRONT.svg";
					param.width = 544.83
					param.height = 450
					param.offsetX = 0
					param.offsetY = 0
				}

				

				let vm = this
				background.onload = async function(){

					destCtx.drawImage(background, param.offsetX , param.offsetY , param.width , param.height );   
					const canvas = document.getElementById(canvasId);
					// console.log(canvas)
				

					destCtx.drawImage(canvas, 0, 0);
					// console.log('test')
					// console.log(destinationCanvas.toDataURL())

					let modifiedFile = vm.dataURLtoFile(destinationCanvas.toDataURL() , 'image.jpg')
				
					let formData = new FormData()

					formData.append('work_order' , modifiedFile)
					
					
					try {
						let url = env.urlStart + "/api/v1/workorder/image"
						let response = await vm.$http.post(url , formData , {headers : {"Content-Type":'multipart/form-data'}})
						let data = response.data.data
						
						vm.data.condition.figureOverall[vm.carTypes].front = {
							image : [data.filename]
						}
						// console.log(data.filename)
						vm.$emit('nextPage')
					}   catch (err) {
						vm.$store.dispatch('triggerAlert' , [false , ['Something Went Wrong. Please Try Again Later.' , err]])
						console.log(err)
					}       
				}
			}
		}
	}
</script>

<style scoped>
	canvas {
		font-family: "Font Awesome 5 Free";
	}

	.color-green {
		color : #29BC53;
	}
	.color-blue {
		color : #007ED9;
	}
	.color-yellow {
		color : #FFDD05;
	}
	.color-red {
		color : #FF0000;
	}

	.btn {
		border-radius: 30px;
		border : 0.5px solid;
	}

	.btn-green {
		background-color: #29BC5326;
		color : black;
	}

	.btn-blue {
		background-color: #007ED926;
		color : black;
	}
	.btn-yellow {
		background-color: #FFDD0526;
		color : black;
	}
	.btn-red {
		background-color: #FF000026;
		color : black;
	}

	.label-car-type {
		display: flex;
		align-items: center;
		letter-spacing: 0.015em;
		font-size: 14px;
	}
</style>
